/**
 * Formata uma lista de addons em texto para exibição
 * Exemplos:
 * - [] -> ''
 * - ['cPanel'] -> 'cPanel'
 * - ['cPanel', 'Plesk'] -> 'cPanel e Plesk'
 * - ['cPanel', 'Plesk', 'Docker'] -> 'cPanel, Plesk e Docker'
 *
 * @param {Array<string>} addons - Lista de nomes de addons
 * @param {string} conjunction - Conjunção a ser usada (padrão: 'e')
 * @returns {string} - String formatada com os addons
 */
export const formatAddonsList = (addons = [], conjunction = 'e') => {
  if (!Array.isArray(addons) || addons.length === 0) {
    return '';
  }

  if (addons.length === 1) {
    const [singleAddon] = addons;
    return singleAddon;
  }

  const [firstAddon, ...restAddons] = addons;
  const lastAddon = restAddons.pop();

  if (restAddons.length === 0) {
    // Apenas 2 itens
    return `${firstAddon} ${conjunction} ${lastAddon}`;
  }

  // 3 ou mais itens
  return `${[firstAddon, ...restAddons].join(', ')} ${conjunction} ${lastAddon}`;
};

export default formatAddonsList;
